(() => {
  if (window.StoreExpertsProductShippingLoaded) return;
  window.StoreExpertsProductShippingLoaded = true;

  const ufMap = {
    AC: 'Acre', AL: 'Alagoas', AP: 'Amapá', AM: 'Amazonas', BA: 'Bahia', CE: 'Ceará', DF: 'Distrito Federal', ES: 'Espírito Santo',
    GO: 'Goiás', MA: 'Maranhão', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', MG: 'Minas Gerais', PA: 'Pará', PB: 'Paraíba',
    PR: 'Paraná', PE: 'Pernambuco', PI: 'Piauí', RJ: 'Rio de Janeiro', RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul',
    RO: 'Rondônia', RR: 'Roraima', SC: 'Santa Catarina', SP: 'São Paulo', SE: 'Sergipe', TO: 'Tocantins'
  };

  const formatCep = (value) => {
    const digits = String(value || '').replace(/\D/g, '').slice(0, 8);
    return digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
  };

  const parsePriceCents = (value) => {
    if (typeof value === 'number') return Math.max(0, Math.round(value * 100));
    const raw = String(value ?? '').trim().replace(/[^\d,.-]/g, '');
    if (!raw) return null;

    let normalized = raw;
    if (raw.includes('.') && raw.includes(',')) normalized = raw.replace(/\./g, '').replace(',', '.');
    else if (raw.includes(',')) normalized = raw.replace(',', '.');

    const parsed = Number.parseFloat(normalized);
    return Number.isFinite(parsed) ? Math.max(0, Math.round(parsed * 100)) : null;
  };

  const formatMoney = (cents, currency = 'BRL') => {
    const value = Number(cents || 0) / 100;
    if (value === 0) return 'Grátis';
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency }).format(value);
    } catch (error) {
      return `R$ ${value.toFixed(2).replace('.', ',')}`;
    }
  };

  const createShippingStore = () => {
    const key = 'se_shipping_quote_v1';
    const ttl = 24 * 60 * 60 * 1000;

    const normalize = (quote) => {
      const zip = String(quote?.zip || '').replace(/\D/g, '').slice(0, 8);
      const priceCents = Number(quote?.rate?.priceCents);
      const expiresAt = Number(quote?.expiresAt);
      if (zip.length !== 8 || !Number.isFinite(priceCents) || priceCents < 0 || !Number.isFinite(expiresAt)) return null;
      return {
        zip,
        address: String(quote.address || ''),
        province: String(quote.province || ''),
        rate: {
          name: String(quote.rate.name || 'Entrega'),
          priceCents,
          deliveryDays: Number.isFinite(Number(quote.rate.deliveryDays)) ? Number(quote.rate.deliveryDays) : null
        },
        createdAt: Number(quote.createdAt || Date.now()),
        expiresAt
      };
    };

    const clear = (notify = true) => {
      try {
        localStorage.removeItem(key);
      } catch (error) {
        // Storage can be unavailable in privacy modes; the cookie is still cleared.
      }
      document.cookie = 'se_shipping_zip=; max-age=0; path=/; SameSite=Lax';
      if (notify) document.dispatchEvent(new CustomEvent('se:shipping-quote-updated', { detail: { quote: null } }));
    };

    const get = () => {
      try {
        const quote = normalize(JSON.parse(localStorage.getItem(key) || 'null'));
        if (!quote || quote.expiresAt <= Date.now()) {
          clear(false);
          return null;
        }
        return quote;
      } catch (error) {
        clear(false);
        return null;
      }
    };

    const save = ({ zip, address = '', province = '', rate, createdAt, expiresAt }) => {
      const now = Date.now();
      const preservedExpiry = Number(expiresAt);
      const quote = normalize({
        zip,
        address,
        province,
        rate,
        createdAt: Number.isFinite(Number(createdAt)) ? Number(createdAt) : now,
        expiresAt: Number.isFinite(preservedExpiry) && preservedExpiry > now ? preservedExpiry : now + ttl
      });
      if (!quote) return null;
      try {
        localStorage.setItem(key, JSON.stringify(quote));
      } catch (error) {
        // The quote remains usable for this page even when storage is unavailable.
      }
      document.cookie = `se_shipping_zip=${quote.zip}; max-age=86400; path=/; SameSite=Lax`;
      document.dispatchEvent(new CustomEvent('se:shipping-quote-updated', { detail: { quote } }));
      return quote;
    };

    return { get, save, clear, formatCep, formatMoney, parsePriceCents };
  };

  window.StoreExpertsShipping = window.StoreExpertsShipping || createShippingStore();
  const shippingStore = window.StoreExpertsShipping;

  const deliveryText = (days) => {
    const parsed = Number(days);
    return Number.isFinite(parsed) && parsed > 0 ? `Entrega em até ${parsed} dias úteis` : '';
  };

  const setMessage = (root, text, isError = false) => {
    const message = root.querySelector('.se-product-shipping__message');
    if (!message) return;
    message.textContent = text || '';
    message.classList.toggle('is-error', Boolean(isError));
  };

  const clearResult = (root) => {
    const result = root.querySelector('.se-product-shipping__result');
    if (result) result.innerHTML = '';
  };

  const showForm = (root, shouldFocus = false) => {
    const form = root.querySelector('[data-shipping-form]');
    const saved = root.querySelector('[data-shipping-saved]');
    if (form) form.hidden = false;
    if (saved) saved.hidden = true;
    clearResult(root);
    setMessage(root, '', false);
    if (shouldFocus) root.querySelector('.se-product-shipping__input')?.focus();
  };

  const renderSavedQuote = (root, quote) => {
    if (!quote) {
      showForm(root);
      return;
    }

    const form = root.querySelector('[data-shipping-form]');
    const saved = root.querySelector('[data-shipping-saved]');
    const title = root.querySelector('[data-shipping-saved-title]');
    const price = root.querySelector('[data-shipping-saved-price]');
    const meta = root.querySelector('[data-shipping-saved-meta]');
    const input = root.querySelector('.se-product-shipping__input');

    if (form) form.hidden = true;
    if (saved) saved.hidden = false;
    if (title) title.textContent = `Frete para ${shippingStore.formatCep(quote.zip)}`;
    if (price) price.textContent = `${quote.rate.name}: ${shippingStore.formatMoney(quote.rate.priceCents)}`;
    if (meta) meta.textContent = [deliveryText(quote.rate.deliveryDays), quote.address].filter(Boolean).join(' · ');
    if (input) input.value = shippingStore.formatCep(quote.zip);
    clearResult(root);
    setMessage(root, '', false);
  };

  const setLoading = (root, state) => {
    const button = root.querySelector('.se-product-shipping__button');
    if (!button) return;
    if (!button.dataset.defaultText) button.dataset.defaultText = button.textContent.trim() || 'Calcular';
    button.classList.toggle('is-loading', Boolean(state));
    button.disabled = Boolean(state);
    button.textContent = state ? 'Calculando...' : button.dataset.defaultText;
  };

  const getVariantId = (root) => {
    const form = root.closest('.product__info-container')?.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    const variantInput = form?.querySelector('[name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (variantInput?.value) return variantInput.value;
    try {
      return new URL(window.location.href).searchParams.get('variant') || '';
    } catch (error) {
      return '';
    }
  };

  const fetchAddress = async (zip) => {
    const response = await fetch(`https://viacep.com.br/ws/${zip}/json/`, { headers: { Accept: 'application/json' } });
    const data = await response.json();
    if (!data || data.erro) throw new Error('CEP não encontrado. Verifique o número e tente novamente.');
    const province = ufMap[data.uf];
    if (!province) throw new Error('Não foi possível identificar o estado do CEP.');
    const address = [data.localidade, data.uf].filter(Boolean).join(' - ');
    return { province, address };
  };

  const requestRates = async (zip, province, country) => {
    const response = await fetch('/cart/shipping_rates.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ shipping_address: { zip, country, province } })
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data?.message || 'Não foi possível calcular o frete.');
    return data;
  };

  const addTemporaryVariant = async (variantId) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', Accept: 'application/json' },
      body: `id=${encodeURIComponent(variantId)}&quantity=1`
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data?.description || data?.message || 'Selecione uma variação disponível para calcular o frete.');
    return data;
  };

  const clearTemporaryCart = async () => {
    await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  };

  const selectCheapestRate = (rates) => {
    if (!Array.isArray(rates)) return null;
    return rates
      .map((rate) => ({ rate, priceCents: shippingStore.parsePriceCents(rate.price) }))
      .filter((entry) => Number.isFinite(entry.priceCents))
      .sort((left, right) => left.priceCents - right.priceCents)[0] || null;
  };

  const calculate = async (root) => {
    const input = root.querySelector('.se-product-shipping__input');
    const zip = String(input?.value || '').replace(/\D/g, '').slice(0, 8);
    const country = root.dataset.country || 'Brazil';
    clearResult(root);
    setMessage(root, '', false);
    if (zip.length !== 8) {
      setMessage(root, 'Por favor, informe um CEP válido com 8 dígitos.', true);
      return;
    }

    setLoading(root, true);
    let addedTemporary = false;
    try {
      const info = await fetchAddress(zip);
      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      if (!cart || Number(cart.item_count || 0) === 0) {
        const variantId = getVariantId(root);
        if (!variantId) throw new Error('Selecione uma variação disponível para calcular o frete.');
        await addTemporaryVariant(variantId);
        addedTemporary = true;
      }

      const data = await requestRates(zip, info.province, country);
      const cheapest = selectCheapestRate(data.shipping_rates);
      if (!cheapest) throw new Error('Não encontramos opções de entrega para este CEP.');

      const days = Array.isArray(cheapest.rate.delivery_days) ? Number.parseInt(cheapest.rate.delivery_days[0], 10) : null;
      const quote = shippingStore.save({
        zip,
        address: info.address,
        province: info.province,
        rate: {
          name: cheapest.rate.name || 'Entrega',
          priceCents: cheapest.priceCents,
          deliveryDays: Number.isFinite(days) ? days : null
        }
      });
      renderSavedQuote(root, quote);
    } catch (error) {
      clearResult(root);
      setMessage(root, error?.message || 'Ocorreu um erro ao calcular o frete.', true);
    } finally {
      if (addedTemporary) await clearTemporaryCart();
      setLoading(root, false);
    }
  };

  const hydrate = () => {
    document.querySelectorAll('[data-se-product-shipping]').forEach((root) => renderSavedQuote(root, shippingStore.get()));
  };

  document.addEventListener('input', (event) => {
    const input = event.target.closest?.('.se-product-shipping__input');
    if (!input) return;
    input.value = shippingStore.formatCep(input.value);
  });

  document.addEventListener('keydown', (event) => {
    const input = event.target.closest?.('.se-product-shipping__input');
    if (!input || event.key !== 'Enter') return;
    event.preventDefault();
    const root = input.closest('[data-se-product-shipping]');
    if (root) calculate(root);
  });

  document.addEventListener('click', (event) => {
    const changeButton = event.target.closest?.('[data-shipping-change]');
    if (changeButton) {
      shippingStore.clear();
      showForm(changeButton.closest('[data-se-product-shipping]'), true);
      return;
    }

    const button = event.target.closest?.('.se-product-shipping__button');
    if (!button) return;
    const root = button.closest('[data-se-product-shipping]');
    if (root) calculate(root);
  });

  document.addEventListener('se:shipping-quote-updated', (event) => {
    document.querySelectorAll('[data-se-product-shipping]').forEach((root) => renderSavedQuote(root, event.detail?.quote || null));
  });
  document.addEventListener('shopify:section:load', hydrate);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate, { once: true });
  else hydrate();
})();
